import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WheelService } from '../wheel.service';
import { SessionService } from '@core/services/session.service';
import { FormsModule } from '@angular/forms';
import { GameIconComponent } from '../../../core/components/game-icon/game-icon.component';
import { InputOptionsComponent } from '../../../core/components/input-options/input-options.component';
import { BalanceIconComponent } from '../../../core/components/balance-icon/balance-icon.component';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { ClipboardService } from '@core/services/clipboard.service';
import { OldSliderComponent } from '@core/components/old-slider/old-slider.component';

@Component({
  selector: 'app-wheel-bet-section',
  templateUrl: './wheel-bet-section.component.html',
  styleUrls: ['./wheel-bet-section.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    GameIconComponent,
    InputOptionsComponent,
    BalanceIconComponent,
    FairnessButtonComponent,
    OldSliderComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'box-black-third rounded-6',
  },
})
export class WheelBetSectionComponent {
  public readonly wheelService = inject(WheelService);
  public readonly sessionService = inject(SessionService);
  public readonly clipboardService = inject(ClipboardService);

  betInputOptions = [
    {
      label: '1/2',
      fn: () => this.setBet('half'),
    },
    {
      label: '2x',
      fn: () => this.setBet('double'),
    },
    {
      label: 'Max',
      fn: () => this.setBet('max'),
    },
  ];

  betButtons = [
    {
      label: '+1',
      fn: () => this.setBet(1),
    },
    {
      label: '+10',
      fn: () => this.setBet(10),
    },
    {
      label: '+25',
      fn: () => this.setBet(25),
    },
    {
      label: '+100',
      fn: () => this.setBet(100),
    },
  ];

  setBet(value: number | 'half' | 'double' | 'max') {
    const { MAX_BET, MIN_BET } = this.wheelService;

    this.wheelService.betAmount.update((prev) => {
      const newValue =
        value === 'half'
          ? Math.floor(prev / 2)
          : value === 'double'
          ? prev * 2
          : value === 'max'
          ? Math.min(
              this.wheelService.MAX_BET,
              this.sessionService.currentBalance()
            )
          : prev + (typeof value === 'number' ? value : 0);

      return Math.min(MAX_BET, Math.max(MIN_BET, newValue));
    });
  }
}
